import React from "react";

interface PharmacistWorkspaceIconProps {
  isActive?: boolean;
}

/** Capsule / Rx mark for Pharmacist Workspace sidebar item. */
export const PharmacistWorkspaceIcon: React.FC<PharmacistWorkspaceIconProps> = ({
  isActive = false,
}) => {
  const color = isActive ? "var(--active-color)" : "#83829D";

  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 3.5H15.5C16.6046 3.5 17.5 4.39543 17.5 5.5V7.5C17.5 8.60457 16.6046 9.5 15.5 9.5H8.5C7.39543 9.5 6.5 8.60457 6.5 7.5V5.5C6.5 4.39543 7.39543 3.5 8.5 3.5Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.5V14"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M9.2 14H14.8C16.4569 14 17.8 15.3431 17.8 17C17.8 18.6569 16.4569 20 14.8 20H9.2C7.54315 20 6.2 18.6569 6.2 17C6.2 15.3431 7.54315 14 9.2 14Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.8 17H14.2"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};
